import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Mail, MapPin } from 'lucide-react';

export default function PrivacidadPage() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="privacidad-page">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <ArrowLeft size={18} className="text-slate-500" />
            <span className="text-sm text-slate-600">Volver a inicio</span>
          </Link>
          <Link to="/">
            <img 
              src="https://customer-assets.emergentagent.com/job_baja-laboral-riesgos/artifacts/m7tg5pgh_logo.jpg" 
              alt="PrevenciónLegal @tecnoabogado" 
              className="h-10 w-auto"
            />
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16">
        <div className="flex items-center gap-3 mb-8">
          <Shield className="text-rose-600" size={32} />
          <h1 className="text-3xl font-bold text-slate-900">Política de Privacidad</h1>
        </div>
        <p className="text-sm text-slate-500 mb-8">Última actualización: Abril 2026</p>

        <div className="prose prose-slate max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">1. Información que Recopilamos</h2>
            <p className="text-slate-600 mb-4">Recopilamos información que nos proporcionas directamente cuando utilizas nuestra plataforma de prevención de riesgos laborales:</p>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li><strong>Información de cuenta:</strong> Nombre, correo electrónico, cargo, empresa</li>
              <li><strong>Datos de contacto:</strong> Información proporcionada en formularios de leads y contacto</li>
              <li><strong>Datos del analizador:</strong> Parámetros introducidos en la calculadora de riesgos (anonimizados)</li>
              <li><strong>Datos técnicos:</strong> Dirección IP, navegador, dispositivo, cookies</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">2. Cómo Utilizamos tu Información</h2>
            <p className="text-slate-600 mb-4">Utilizamos la información recopilada para:</p>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li>Proporcionar información y recursos sobre prevención de riesgos laborales</li>
              <li>Responder a consultas y solicitudes de asesoramiento</li>
              <li>Enviar comunicaciones relevantes sobre normativa y actualizaciones (con tu consentimiento)</li>
              <li>Mejorar nuestros servicios y contenidos</li>
              <li>Cumplir con obligaciones legales (GDPR, LOPDGDD, AEPD)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">3. Base Legal para el Procesamiento (GDPR)</h2>
            <p className="text-slate-600 mb-4">Procesamos tus datos personales bajo las siguientes bases legales:</p>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li><strong>Consentimiento (Art. 6(1)(a) GDPR):</strong> Para envío de comunicaciones y marketing</li>
              <li><strong>Ejecución de contrato (Art. 6(1)(b) GDPR):</strong> Para proporcionar servicios de asesoramiento</li>
              <li><strong>Interés legítimo (Art. 6(1)(f) GDPR):</strong> Para mejorar la seguridad y prevenir fraude</li>
              <li><strong>Obligación legal (Art. 6(1)(c) GDPR):</strong> Para cumplir con LOPDGDD y AEPD</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">4. Compartir Información con Terceros</h2>
            <p className="text-slate-600 mb-4">Compartimos información con los siguientes proveedores de servicios:</p>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li><strong>Resend:</strong> Proveedor de servicios de email para notificaciones</li>
              <li><strong>MongoDB Atlas:</strong> Almacenamiento seguro de datos</li>
            </ul>
            <p className="text-slate-600 mt-4 font-semibold">NO vendemos tus datos personales a terceros bajo ninguna circunstancia.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">5. Retención de Datos</h2>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li><strong>Datos de leads y contacto:</strong> 3 años o hasta que solicites su eliminación</li>
              <li><strong>Datos de cuenta:</strong> Mientras tu cuenta esté activa</li>
              <li><strong>Logs de auditoría:</strong> 1 año (cumplimiento legal)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">6. Tus Derechos (GDPR)</h2>
            <p className="text-slate-600 mb-4">Tienes los siguientes derechos sobre tus datos personales:</p>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li><strong>Derecho de acceso (Art. 15):</strong> Solicitar una copia de tus datos</li>
              <li><strong>Derecho de rectificación (Art. 16):</strong> Corregir datos inexactos</li>
              <li><strong>Derecho al olvido (Art. 17):</strong> Solicitar la eliminación de tus datos</li>
              <li><strong>Derecho a la portabilidad (Art. 20):</strong> Recibir tus datos en formato estructurado</li>
              <li><strong>Derecho de oposición (Art. 21):</strong> Oponerte al procesamiento de tus datos</li>
              <li><strong>Derecho a retirar consentimiento:</strong> En cualquier momento</li>
            </ul>
            <p className="text-slate-600 mt-4">Para ejercer estos derechos, contacta a: <a href="mailto:info@tecnoabogado.com" className="text-rose-600 hover:underline">info@tecnoabogado.com</a></p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">7. Cumplimiento AEPD (España)</h2>
            <p className="text-slate-600">Estamos registrados como responsable de tratamiento ante la Agencia Española de Protección de Datos (AEPD). En caso de brecha de datos, notificaremos a la AEPD en menos de 72 horas.</p>
            <p className="text-slate-600 mt-2">Más información: <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline">www.aepd.es</a></p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">8. Seguridad de los Datos</h2>
            <p className="text-slate-600 mb-4">Implementamos medidas de seguridad técnicas y organizativas:</p>
            <ul className="list-disc pl-6 space-y-2 text-slate-600">
              <li>Cifrado en tránsito (TLS 1.3)</li>
              <li>Cifrado en reposo (AES-256)</li>
              <li>Control de acceso basado en roles</li>
              <li>Auditorías de seguridad regulares</li>
            </ul>
          </section>

          <section className="bg-slate-100 p-6 border border-slate-200">
            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-2">
              <Mail size={20} />
              Contacto
            </h2>
            <p className="text-slate-600 mb-4">Para preguntas sobre privacidad o ejercer tus derechos:</p>
            <ul className="space-y-2 text-slate-600">
              <li><strong>Responsable:</strong> José Luis Vilaplana (@tecnoabogado)</li>
              <li><strong>Email:</strong> <a href="mailto:info@tecnoabogado.com" className="text-rose-600 hover:underline">info@tecnoabogado.com</a></li>
              <li><strong>Autoridad de control:</strong> Agencia Española de Protección de Datos (AEPD)</li>
            </ul>
          </section>
        </div>
      </main>

      {/* Footer simple */}
      <footer className="bg-slate-900 text-slate-400 py-8 px-6">
        <div className="max-w-4xl mx-auto text-center text-sm">
          <p>© 2026 vilaplana@tecnoabogado. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
}
